

import {AfterViewInit, Component, HostListener, OnDestroy} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import {Subscription} from 'rxjs';
import {filter} from 'rxjs/operators';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent  implements AfterViewInit, OnDestroy {
  title = 'Albertsons-B2B';
  private routerSubscription: Subscription;
  visible:boolean = true;
  screenWidth: number = 0;
  hideMob: boolean = false;
  currentRoute:string="";
  constructor(private router: Router) {
  }
  ngAfterViewInit(): void {
    this.routerSubscription = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: any) => { //.subscribe((event: NavigationEnd) => {

        this.currentRoute=event.url == "/" ? "/contact":event.url;

        window.parent.postMessage("resize::"+this.currentRoute,"*");
      });
      
      document.body.scrollTop = 0;

  }
  ngOnDestroy(): void {
    this.routerSubscription.unsubscribe();
  }
  ngOnInit(): void {
    this.screenWidth = window.innerWidth;
    this.hideMob = this.screenWidth <=  767;
  }

  hasRoute(route: string) {
    return this.router.url.includes(route);
  }

  @HostListener('window:resize', ['$event'])
    onResize(event?: any) {
      this.screenWidth = window.innerWidth;
      this.hideMob = this.screenWidth <=  767;
    }
}
